<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-form-item label="文章选项:">
        <el-radio v-model="form.status" label=1>无封面文章</el-radio>
        <el-radio v-model="form.status" label=2>封面文章</el-radio>
      </el-form-item>
      <el-form-item label="文章封面:" v-if="form.status  == '2'">
        <el-upload class="avatar-uploader" action="api/article/upphoto" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
          <img v-if="form.photo" :src="form.photo" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="文章类型:" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option v-for="item in typeList" :key="item.id" :label="item.type" :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章标签:" prop="label">
        <el-select class="label-select" v-model="form.label" multiple filterable default-first-option placeholder="请选择文章标签" @change="da()">
          <el-option v-for="item in labelList" :key="item.id" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章标题:" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="文章描述:" prop="description">
        <el-input v-model="form.description" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="文章内容:" prop="content">
        <quill-editor v-model="form.content"   />
      </el-form-item>
      <el-form-item label="文章时间:" prop="time">
        <el-date-picker v-model="form.time" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="文章开关:">
        <el-switch v-model="form.switch" active-color="#13ce66" inactive-color="#ff4949" inactive-value=0
          active-value=1>
        </el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="onSubmit('form')">{{
          editID == 0 ? "添加" : "修改"
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    editID: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      imageUrl: "",
      form: {
        status:'1',
        photo: '',
        type: '',
        label:[],
        title: '',
        content: '',
        description: '',
        time: '',
        switch: 0
      },
      rules: {
        title: [{ required: true, message: "请输入文章标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入文章内容", trigger: "blur" }],
        time: [{ required: true, message: "请选择文章时间", trigger: "blur" }],
        type: [{ required: true, message: "请选择文章类型", trigger: "blur" }],
        label: [{ required: true, message: "请选择文章标签", trigger: "blur" }],
      },
      typeList: {},
      labelList:{}
    };
  },
  methods: {
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
      this.form.photo = URL.createObjectURL(file.raw);
      this.$message.success(res.meta.msg);
    },
    da(e){
      console.log(e);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传封面图片只能是 JPG或者PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传封面图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    onSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$message.error("添加失败");
          return false;
        }
        if (this.editID > 0) {
          const { data: res } = await this.$axios.post(
            "/article/editArticle",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        } else {
          const { data: res } = await this.$axios.post(
            "article/addArticle",
            this.form
          );
          console.log(res);
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg);
          this.$emit("onDialog", false);
          return this.$message.success(res.meta.msg);
        }
      });
    },
    onDropdown() {

    },
    async getArticle(id) {
      const { data: res } = await this.$axios.post("/article/getArticleId", {
        id: id,
      });
      console.log(res);
      this.form = res.data;
    },
    async getArticleType() {
      const { data: res } = await this.$axios.post("/type", {
        keywords: '',
        page: 1,
        pageSize: 100,
      });
      this.typeList = res.data.list;
      console.log(res);
    },
    async getArticleLable() {
      const { data: res } = await this.$axios.post("/label", {
        keywords: '',
        page: 1,
        pageSize: 100,
      });
      this.labelList = res.data.list;
      console.log(res);
    },
  },
  created() {
    this.getArticleType();
    this.getArticleLable();
    if (this.editID > 0) {
      console.log(this.editID);
      this.getArticle(this.editID);
    }
  },
}
</script>

<style lang="less">
.avatar-uploader .el-upload {
  border: 1px dashed #666;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-input,
.el-textarea {
  max-width: 800px;
}

.label-select{
  width: 100%;
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/article/addArticle.vue